import { render, staticRenderFns } from "./Transactionlisting.vue?vue&type=template&id=24bdcad5"
import script from "./Transactionlisting.vue?vue&type=script&lang=js"
export * from "./Transactionlisting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports